import React from 'react'
import classnames from 'classnames'

import {
  DUMMY_SLIDES
} from './TipsPreview'

const GIF_URL = 'https://checksub-website-assets.s3.eu-west-2.amazonaws.com/onboarding_assets/onboarding_preview_tips.gif'

interface CarouselCardProps {
  readonly slide: typeof DUMMY_SLIDES[number]
  readonly direction: 'left' | 'right'
}

const CarouselCard: React.FC<CarouselCardProps> = (props) => {
  const { slide, direction } = props

  return (
    <div
      className={classnames({
        'TipsPreview__slide-right': direction === 'right',
        'TipsPreview__slide-left': direction === 'left'
      })}
    >
      <div className="TipsPreview__card">
        <div className="TipsPreview__media">
          <img
            src={GIF_URL}
            alt={slide.title}
            className="TipsPreview__media-gif"
          />
        </div>
        <div className="TipsPreview__card-content">
          <h2 className="TipsPreview__card-title">{slide.title}</h2>
          <p className="TipsPreview__card-description">{slide.description}</p>
        </div>
      </div>
    </div>
  )
}

export default CarouselCard
